if (__DEV__)
  require('preact/debug')

import { render } from 'preact'

import { App } from './components/app'

document.addEventListener('DOMContentLoaded', () => {
  render(<App />, document.body)
})
